/**
 * The ack's world lists — resource nodes, NPCs, shrines — as the HUD and panels may
 * measure or plot them against the player's body (q-dungeon-run-world-overlays-leak).
 *
 * Inside a dungeon run the entities (our body included) are the instance's, in the
 * plan's frame; the ack's lists are still the open world's, in ITS frame. Read
 * together, a world node near the world origin plots beside the run body and a
 * world NPC lists as "nearby" — so in a run there are none. Display only: the
 * server already refuses a world talk / gather / travel from inside a run.
 */

import type { ClientState } from '../state/store.js';

type WorldLists = Pick<ClientState, 'ack' | 'nodes' | 'inDungeonRun'>;

export interface WorldFrame {
  nodes: ClientState['nodes'];
  npcs: NonNullable<ClientState['ack']>['npcs'];
  shrines: NonNullable<ClientState['ack']>['world']['shrines'];
}

const NONE: WorldFrame = { nodes: [], npcs: [], shrines: [] };

export function worldFrame(state: WorldLists): WorldFrame {
  if (state.inDungeonRun) return NONE;
  return {
    nodes: state.nodes,
    npcs: state.ack?.npcs ?? [],
    shrines: state.ack?.world.shrines ?? [],
  };
}
